import { Injectable } from '@angular/core';
import { SpacesClientService } from '@mode/shared/data-access-webapp';
import { Observable } from 'rxjs';
import { SpaceDomain } from '@mode/shared/contract-common';

@Injectable({
  providedIn: 'root',
})
export class SpacesIndexViewFacade {
  constructor(private spacesClientService: SpacesClientService) {}

  public searchCollections(
    workspaceId: string,
    pageNumber: number,
    query = ''
  ): Observable<SpaceDomain.CollectionsSearchResult> {
    return this.spacesClientService.searchCollections(workspaceId, pageNumber, query);
  }
}
